import State from "@/store/facebook/authentication"
import Authentication from "@/managers/facebook/authentication"

class Permissions {
	private readonly pagePermissions = ["pages_show_list", "pages_manage_posts", "pages_read_engagement", "pages_read_user_content", "pages_manage_metadata", "pages_manage_engagement", "pages_messaging", "read_insights", "business_management"]
	private readonly instagramPermissions = ["pages_show_list", "pages_read_engagement", "instagram_basic", "instagram_content_publish", "instagram_manage_insights"]

	private readonly pageSubscriptionPermissions = ["pages_utility_messaging"]

	public get hasCheckedPermissions(): boolean {
		return State.hasCheckedPermissions
	}

	public get hasPermissionsChanged(): boolean {
		return State.hasPermissionsChanged
	}

	public hasPagePermissions(includeSubscription: boolean): boolean {
		return this.getPagePermissions(includeSubscription).every(p => State.grantedPermissions.indexOf(p) !== -1)
	}

	public hasInstagramPermissions(): boolean {
		return this.instagramPermissions.every(p => State.grantedPermissions.indexOf(p) !== -1)
	}

	public requestPagePermissions(includeSubscription: boolean): Promise<boolean> {
		return Authentication.requestPermissions(this.getPagePermissions(includeSubscription))
	}

	public requestInstagramPermissions(): Promise<boolean> {
		return Authentication.requestPermissions(this.instagramPermissions)
	}

	public requestAllPermissions(includeSubscription: boolean): Promise<boolean> {
		return Authentication.requestPermissions(this.getAllPermissions(includeSubscription))
	}

	private getPagePermissions(includeSubscription: boolean): string[] {
		return includeSubscription ? this.pagePermissions.concat(this.pageSubscriptionPermissions) : this.pagePermissions
	}

	private getAllPermissions(includeSubscription: boolean): string[] {
		const pagePermission = this.getPagePermissions(includeSubscription)

		return Array.from(new Set(pagePermission.concat(this.instagramPermissions))) // Make sure permissions are unique
	}
}

export default new Permissions()
